/**
 * Mail constants
 */

export const SIGNUP_INVITE_TEMPLATE_NAME = 'signup-invite'
export const TEAM_INVITE_TEMPLATE_NAME   = 'team-invite'
export const LIST_INVITE_TEMPLATE_NAME   = 'pricelist-invite'
